import { supabase } from "./supabase";
import { ERSTE_HAUSHALTE_SCENARIO } from "./ersteHaushalte";

const SESSION_KEY = "albis_erste_haushalte_session";

/**
 * Stable id for one browser pass through Erste Haushalte.
 * @returns {string}
 */
export function getErsteHaushalteSessionId() {
  try {
    const existing = sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `eh-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, id);
    return id;
  } catch {
    return `eh-${Date.now()}`;
  }
}

/**
 * Persist one Erste Haushalte answer (GA4 is sent by the caller).
 * Failures are swallowed — logging must not block UX.
 *
 * @param {{
 *   answer: string,
 *   detail?: string | null,
 *   utmSource?: string | null,
 *   utmScenario?: string | null,
 * }} payload
 */
export async function logErsteHaushalteResponse(payload) {
  try {
    const row = {
      session_id: getErsteHaushalteSessionId(),
      answer: payload.answer,
      detail: payload.answer === "other" ? payload.detail || null : null,
      utm_source: payload.utmSource || null,
      utm_scenario: payload.utmScenario || ERSTE_HAUSHALTE_SCENARIO,
    };
    const { error } = await supabase.from("erste_haushalte_responses").insert(row);
    if (error) {
      console.warn("erste_haushalte_responses insert failed", error.message);
    }
  } catch (err) {
    console.warn(
      "erste_haushalte_responses insert failed",
      err instanceof Error ? err.message : err,
    );
  }
}
